import { ExternalLink } from "lucide-react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { TopographicLines } from "../components/TopographicLines";
import { useI18n } from "../i18n";

export function ResearchPage() {
  const { messages } = useI18n();

  return (
    <>
      <Header />
      <main className="research-page">
        <section className="page-hero">
          <TopographicLines className="page-hero__contours" />
          <div className="shell page-hero__inner">
            <div>
              <h1>{messages.research.title}</h1>
              <p>{messages.research.intro}</p>
            </div>
            <div className="journal-principle">
              <strong>{messages.research.hypothesisLabel}</strong>
              <p>{messages.research.hypothesisBody}</p>
            </div>
          </div>
        </section>

        <section className="research-section section">
          <div className="shell">
            <div className="research-section__heading">
              <h2>{messages.research.gatesTitle}</h2>
              <p>{messages.research.gatesBody}</p>
            </div>
            <div className="decision-metrics">
              {messages.research.metrics.map((metric) => (
                <article key={metric.label}>
                  <strong>
                    <bdi dir="ltr">{metric.value}</bdi>
                  </strong>
                  <h3>{metric.label}</h3>
                  <p>{metric.note}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="method-section section">
          <div className="shell method-section__grid">
            <div>
              <h2>{messages.research.testTitle}</h2>
              <ol>
                {messages.research.tests.map((item) => (
                  <li key={item.title}>
                    <strong>{item.title}</strong>
                    <p>{item.body}</p>
                  </li>
                ))}
              </ol>
            </div>
            <div>
              <h2>{messages.research.guardrailsTitle}</h2>
              <ul className="guardrail-list">
                {messages.research.guardrails.map((guardrail) => (
                  <li key={guardrail}>{guardrail}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section className="source-library section">
          <div className="shell source-library__grid">
            <div>
              <h2>{messages.research.sourcesTitle}</h2>
              <p>{messages.research.sourcesBody}</p>
            </div>
            <ul>
              {messages.research.sources.map((source) => (
                <li key={source.href}>
                  <a href={source.href} target="_blank" rel="noreferrer">
                    {source.label}
                    <ExternalLink size={16} aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
